

export type ToastKey = keyof typeof TOAST_MESSAGES;
export const TOAST_MESSAGES = {
  // Admin registration page
  accountCreated: "Account created successfully!",
  accountUpdated: "Account updated successfully!",
  accountDeleted: "Account deleted successfully!",
  loginSuccess: "Login successful!",
  logoutSuccess: "You have logged out successfully!",
  invalidPanFormat: "Invalid PAN format. Please enter a valid PAN.",

  // General
  errorGeneric: "Something went wrong. Please try again.",
  unexpectedError: "An unexpected error occurred.",
  companyIdMissing: "Company ID missing",
  selectBranch: "Please select a branch.",
  errorNetwork: "Network error. Please check your connection and try again.",
  paymentSuccess: "Payment completed successfully!",
  paymentFailed: "Payment failed. Please try again.",
  allUsersCheckedOut: "All users checked out from this branch.",
  deviceAdded: "Device added successfully!",
  deviceConnected: "Device connected successfully!",
  deviceOffline: "Device is offline.",
  prefixRequired: "Prefix is required.",
  prefixAlreadyUsed: "Prefix is already used. Enter a unique one.",
  branchCreated: "Branch created successfully!",
  serviceSelectionRequired: "Please select at least one service offered.",
  customPrefixRequired:
    "Please fill in the custom prefix and increment number.",
  branchNameUnique: "Branch name must be unique.",
  branchVerified: "Branch verified via mobile and email!",
  mobileOtpInvalid: "Mobile OTP must be a 6-digit number.",
  branchVerifiedMobile: "Branch verified via mobile!",
  emailOtpInvalid: "Email OTP must be a 6-digit number.",
  branchVerifiedEmail: "Branch verified via email!",
  branchAddedWithoutVerification: "Branch added without verification.",
  branchUpdated: "Branch updated successfully!",
  copiedToClipboard: "Copied to clipboard!",
  noDataInDocuments: "No data found in the documents.",
  prefixAlreadyUsedAlt: "Prefix is already used. Enter a unique one.",
  mobileNumberRequiredError: "Mobile number is required.",
  BranchActivated: "Branch activated successfully!",
  BranchDeactivated: "Branch deactivated successfully!",

  // Profile
  dataRefreshed: "Data refreshed successfully!",
  profileUpdated: "Profile updated successfully!",

  // Login page
  emailNotVerified: "Email is not verified. Please verify your email first.",
  accountNotAssociated:
    "Your account is not associated with any company. Please contact support.",
  accountNoRoles:
    "Your account is not associated with any roles. Please contact support.",

  // Members
  enterCorrectNumber: "Please enter a valid number.",
  memberCreated: "Member created successfully!",
  minimumAge14: "You must be at least 14 years old.",
  memberAlreadyBranchMember: "The member is already part of this branch.",
  otpSentRequestUser: "OTP sent successfully. Please ask OTP from the user.",
  invalidPhoneNumber: "Invalid phone number.",
  exerciseSelectionRequired: "Please select an exercise first.",
  memberDataIncomplete: "Member data is incomplete.",
  packageRequired: "Please select a package.",
  packageDetailsMissing: "Package details are missing.",
  paymentLinkSent: "Payment link has been sent.",
  otpInvalid: "OTP must be a 6-digit number.",
  wrongOtp: "OTP is incorrect. Please try again.",
  mobileOtpResent: "Mobile OTP resent successfully.",
  // Packages
  packageNameUnique: "Package name must be unique.",
  packageAssignedToMember: "Package is assigned to a member.",
  packageRemoved: "Package removed successfully!",
  packageNotFound: "Package not found.",
  expenseDeleted: "Expense deleted successfully!",
  paymentDeleted: "Payment deleted successfully!",
  noPackageSelected: "No package selected to assign.",
  packageAssigned: "Package assigned successfully!",
  packageAssignFailed: "Failed to assign package. Please try again.",
  packageAssignedCannotDelete:
    "This package is assigned to a member and cannot be deleted.",
  branchSelectionRequired: "Please select at least one branch.",
  packageCreated: "Package created successfully!",
  packageandbranchrequired: "Please select package and branch both.",
  subscriptionDaterequired: "Please select subscription date.",

  // Payments
  createInvoiceFirst:
    "Please create an invoice for this member before adding payment.",
  paymentModeRequired: "Please select a payment mode.",
  depositModeRequired: "Please select a deposit mode.",

  // Company registration
  mobileNumberRequired: "Mobile number is required.",
  otpSent: "OTP sent successfully!",
  emailOtpRequired: "Email OTP is required.",
  mobileOtpRequired: "Mobile OTP is required.",
  registrationSuccessful:
    "Registration successful. You can now login with your email and password.",
  requiredFieldsMissing: "Please fill in all required fields.",
  branchCountMin1: "Branch count must be at least 1.",

  // Branches map
  branchContactOrEmailRequired:
    "Branch must have either a contact number or an email.",
  branchAlreadySelected: "Branch is already selected.",
  maximumBranchesSelected:
    "Maximum branches selected. Please verify or remove a branch.",
  branchAlreadyVerified: "Branch is already verified.",

  // Attendance
  attendanceModeRequired: "Please select an attendance mode.",
  workHoursModeChanged:
    "Work hours mode has been changed and will be reflected soon.",
  workHoursModeCancelled: "Work hours mode has been cancelled.",

  // Banking
  accountNameNicknameRequired: "Please provide both account name and nickname.",
  accountNameNicknameExists: "Account name or nickname already exists.",
  bankingDataUpdated: "Banking data updated successfully!",

  // Business hours
  businessDaysRequired: "Please select business days.",
  businessHoursRequired: "Business hours are required.",
  shiftHoursRequired: "Shift from and shift to hours are required.",
  businessHoursRequiredForDays:
    "Business hours required for the selected days.",
  shiftBusinessHoursRequired:
    "Shift business hours required for the selected days.",
  businessHoursSaved: "Business hours saved successfully!",

  // Specific hour
  nameRequired: "Please enter a name.",
  branchRequired: "Please select a branch.",

  // Equipment
  equipmentNameRequired: "Please enter equipment name.",
  typeRequired: "Please select equipment type.",
  nextMaintenanceDateRequired: "Please select next maintenance date.",
  equipmentAdded: "Equipment added successfully!",
  transferredToNewBranch: "Equipment transferred to new branch!",
  validNameRequired: "Please enter a valid name.",
  noChangesDetected: "No changes detected to update.",
  equipmentUpdated: "Equipment updated successfully!",

  // Holiday
  holidayNameDateRequired: "Please enter both name and date for the holiday.",
  validDateRequired: "Please enter a valid date.",
  holidayUpdated: "Holiday updated successfully!",
  holidayDeleted: "Holiday deleted successfully!",
  holidayNameDateRequiredEach:
    "Please enter both name and date for each holiday.",
  holidaysSaved: "Holidays saved successfully!",

  //leave
  leaveTypeRequired: "Please select a leave type.",
  leaveDateRequired: "Please select a leave date.",
  leaveAdded: "Leave added successfully!",
  leaveUpdated: "Leave updated successfully!",
  leaveDeleted: "Leave deleted successfully!",
  leaveApproved: "Leave approved successfully!",
  leaveRejected: "Leave rejected successfully!",
  leaveRequestUpdated: "Leave request updated successfully!",
  leaveRequestDeleted: "Leave request deleted successfully!",

  // Payment method
  upiIdExists: "UPI ID already exists.",
  paymentMethodAdded: "Payment method added successfully!",
  allFieldsRequired: "All fields are required.",
  paymentMethodUpdated: "Payment method updated successfully!",
  paymentUpdated: "Payment updated successfully!",

  // Payroll
  payPeriodRequired: "Pay period is required.",
  monthlyPayrollDetailsRequired:
    "Please provide all required monthly payroll details, including process date.",
  weeklyPayrollDetailsRequired:
    "Please provide all required weekly payroll details, including process date.",
  biweeklyPayrollDetailsRequired:
    "Please provide all required biweekly payroll details, including process date.",
  payrollSettingsCreated: "Payroll settings created successfully!",
  payrollSettingsUpdated: "Payroll settings updated successfully!",
  noPayrollChangesDetected: "No changes detected in payroll settings.",

  // Chat
  userSelectionRequired: "Please select at least one user.",
  groupChatCreated: "Group chat created successfully!",
  groupChatCreateFailed: "Failed to create group chat. Please try again.",

  // Subscription
  loginRequired: "Please login to proceed.",

  // Enquiry
  enquiryNameRequired: "Please enter enquiry name.",
  leadOwnerRequired: "Please select a lead owner.",
  invalidMobileNumber: "Invalid mobile number.",
  invalidEmailAddress: "Invalid email address. Please enter a valid email.",
  duplicateEntry: "This entry already exists.",
  newEnquiryAdded: "New enquiry added successfully!",
  requiredFieldMissing: "Please fill in required field.",
  newCampaignAdded: "New campaign added successfully!",
  newSourceAdded: "New source added successfully!",
  statusUpdated: "Status updated successfully!",

  // Getting started
  enableStaffAttendance:
    "Please enable staff attendance before enabling payroll.",
  actionNotFound: "Action not found.",

  // Member import
  templateDownloaded: "Template downloaded with sample data.",
  dataCleared: "Data cleared.",
  noDataToSubmit: "No data to submit.",

  // Staff import
  fileSizeLimit: "File size must be less than 10MB.",
  invalidFileType: "Please upload only Excel (.xlsx, .xls) or CSV files.",
  templateDownloadedWithRoles:
    "Template downloaded with sample data and role options.",
  dataClearedSuccessfully: "Data cleared successfully!",

  // Renew payment
  standardPackageRequired: "Please select a standard package.",
  subscriptionDateRequired: "Please select a subscription date.",
  amountLessThanTotal: "The amount entered is less than the total.",
  paymentRenewed: "Payment renewed successfully!",

  // Check-in
  checkedInSuccessfully: "You have checked in successfully!",
  geoRestrictionInvalid: "Geo restriction data is invalid.",
  outsideCheckinLocation: "You are outside the allowed check-in location.",
  ipNotAllowedCheckin: "Your IP address is not allowed for check-in.",
  locationRetrievalFailed: "Unable to retrieve location.",
  geoNotSupported: "Geolocation is not supported by your browser.",
  checkedOutSuccessfully: "You have checked out successfully!",
  checkinFailed: "Check-in failed. Please try again.",
  checkoutFailed: "Check-out failed. Please try again.",

  // Geo restriction
  searchQueryRequired: "Please enter a search query.",
  locationFound: "Location found!",
  locationNotFound: "Location not found. Please try a different search term.",
  currentLocationDetected: "Current location detected!",
  geoRestrictionSaved: "Geo restriction saved successfully!",
  ipRestrictionSaved: "IP restriction saved successfully!",

  // Admin
  emailUpdated: "Email updated successfully!",
  emailAlreadyAssigned: "This email is already assigned to this branch.",
  userAlreadyBranchAdmin: "This user is already a branch admin.",
  userAddedSuccessfully: "User added successfully!",
  userRemovedSuccessfully: "User removed successfully!",
  userRoleUpdated: "User role updated successfully!",
  userAlreadyCompanyAdmin: "This user is already a company admin.",
  emailAlreadyAssignedTrainer:
    "This email is already assigned to this branch as a trainer.",
  staffAdminAndRolesDeleted: "Staff admin and roles deleted successfully.",
  staffRoleRemoved: "Staff role removed successfully!",
  roleAssigned: "Role assigned successfully!",

  // Error
  branchNotCreated: "Branch not created.",
  leaveOverlapping: "You already have a leave request for these dates.",
  nonWorkingDay: "You can only apply leave for scheduled working days.",
  holidayBlocked: "You cannot apply leave for a holiday.",
  nonWorkingDayDetail: "You cannot apply leave for a non-working day.",
  prefixAutoConflict: "Custom prefix cannot be the same as the auto-generate prefix.",
  prefixManualConflict: "Manual member code cannot start with the auto or custom prefix.",
  supportRequestSent: "Support request sent successfully!",
  supportRequestFailed: "Failed to send support request. Please try again.",
  policyAccepted: "Privacy policy accepted successfully.",
  policyAcceptanceError: "Failed to save policy acceptance. Please try again.",
  agreementTemplateNotFound: "Agreement template not found.",
  failedToFetchAgreement: "Failed to fetch agreement template.",
  agreementAccepted: "Agreement accepted successfully.",
  failedToSaveAcceptance: "Failed to save agreement acceptance.",
} as const;
